// Shopify Infinite Scroll (No Conflict)
document.addEventListener("DOMContentLoaded", function () {

    // Pagination bölümü yoksa çık
    var pagination = document.querySelector("#collection-Pagination");
    if (!pagination) return;

    // Önce selector olarak hangisi varsa belirle
    var containerSelector = null;

    if (document.querySelector(".product-grid-view")) {
        containerSelector = ".product-grid-view";
    } else if (document.querySelector(".product-list-view")) {
        containerSelector = ".product-list-view";
    }

    if (!containerSelector) return;

    // Ajaxinate'i başlat
    new Ajaxinate({
        container: containerSelector,  // ← BURASI STRING OLMAK ZORUNDA!
        pagination: "#collection-Pagination",
        loadingText:
            '<img src="https://cdn.shopify.com/s/files/1/0751/3771/2446/files/813.gif?v=1692071901" class="infinity-loader">',
        callback: function () {
            console.log("Infinite scroll → ürünler yüklendi");
        },
    });
});
